import React, { useEffect, useState } from 'react';
const START_SECONDS = 23 * 3600 + 59 * 60 + 51;
function pad(value: number): string {
  return value.toString().padStart(2, '0');
}
export function Countdown() {
  const [remaining, setRemaining] = useState(START_SECONDS);
  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(prev => prev <= 0 ? 0 : prev - 1);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const units = [{
    value: Math.floor(remaining / 3600),
    label: 'HOURS'
  }, {
    value: Math.floor(remaining % 3600 / 60),
    label: 'MINUTES'
  }, {
    value: remaining % 60,
    label: 'SECONDS'
  }];
  return <div className="flex items-start justify-center gap-2 sm:gap-4" role="timer" aria-live="off" aria-label={`Offer ends in ${units[0].value} hours ${units[1].value} minutes ${units[2].value} seconds`} data-id="element-46" data-mp="325j64k3876xi">
      {units.map((unit, index) => <React.Fragment key={unit.label} data-id="element-47" data-mp="15ad8ps9ayili" data-mpi={index}>
          <div className="flex flex-col items-center" data-id="element-48" data-mp="1592a06ups119">
            <span className="flex h-14 w-14 items-center justify-center rounded-xl bg-court-950 font-display text-2xl font-black tabular-nums text-ball sm:h-24 sm:w-24 sm:rounded-2xl sm:text-5xl" data-id="element-49" data-mp="xzvibdkd1416">
              {pad(unit.value)}
            </span>
            <span className="mt-1 text-[9px] font-semibold tracking-[0.16em] text-court-600 sm:mt-2 sm:text-[10px] sm:tracking-[0.18em]" data-id="element-50" data-mp="17sswj7ibk6tz">
              {unit.label}
            </span>
          </div>
          {index < units.length - 1 && <span className="font-display text-2xl font-black leading-[3.5rem] text-court-700 sm:text-5xl sm:leading-[6rem]" data-id="element-51" data-mp="a49armo3085m">
              :
            </span>}
        </React.Fragment>)}
    </div>;
}